<template>
  <div class="col-12 px-0">
    <b-input-group prepend="Annual Spend ( £ )" class="mb-2 mr-sm-2 mb-sm-0 calculator-input">
      <b-form-input id="inline-form-input-spend" :maxlength="18" v-model="annualSpend" placeholder="Annual Spend"></b-form-input>
    </b-input-group>

    <b-input-group prepend="Additional Days Terms" class="mb-2 mr-sm-2 mb-sm-0 calculator-input">
      <b-form-input id="inline-form-input-days" :maxlength="6" v-model="additionalDays" placeholder="Additional Days"></b-form-input>
    </b-input-group>

    <b-input-group prepend="Time Period ( days )" class="mb-2 mr-sm-2 mb-sm-0 calculator-input">
      <b-form-input id="inline-form-input-time" :maxlength="6" v-model="timePeriod" placeholder="Time Period"></b-form-input>
    </b-input-group>

    <div class="capital-result text-center col-12 px-0 mt-4">
      Working Capital Released<br> 
      <span :title="workingCapital" class="deep-orange font-weight-bold">£{{ workingCapital | abbreviate }}</span>
    </div>
  </div>
</template>

<script>

export default {
  name: 'WorkingCapitalCalculator',
  data() {
    return {
      annualSpend: null,
      additionalDays: null,
      timePeriod: null
    }
  },
  computed: {
    workingCapital() {
      if(this.additionalDays > 0 && this.timePeriod > 0 && this.annualSpend > 0) {
        let capital = (this.additionalDays / this.timePeriod) * this.annualSpend
        return capital.toFixed(2)
      }
      return 0
    }
  },
  components: {
    
  }
}
</script>
<style scoped>
  .line {
    border: 0px;
    margin: 5px 0px 5px 0px;
    height: 1px;
    background-color: rgba(83, 101, 140, 0.33);
    width: 100%;
  }
  .calculator-title {
    font-size: 22px;
    color: #047bf8;
  }
  .calculator-input {
    margin-bottom: 10px !important;
  }
  .calculator-input > .input-group-prepend > .input-group-text {
    background-color: #047bf8 !important;
    cursor: default;
    color: white;
    width: 100%;
  }
  .capital-result {
    font-size: 24px;
    color: #047bf8;
  }
  .deep-orange {
    color: #FF5722;
    font-size: 40px;
  }
  .blue-grey {
    color: #607D8B;
  }
  .relative-position {
    position: relative;
  }
  .input-group-prepend {
  width : 60%;
  }

  .input-group-prepend > .form-control {
    width: 100%;
    overflow: hidden;
  }
</style>